<template>
  <div class="flex flex-col justify-center text-left">
    <label v-if="name"
      class="text-base text-gray-600 pl-2 pb-2 font-light uppercase tracking-widest">
      {{ name }}
    </label>
    <label
      class="bg-beige-academy-200
      block border-b-2 border-grey-academy-200 p-1 pl-2"
    >
      {{ value }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: {},
    value: {},
    type: {
      default: 'text',
    },
  },

  computed: {
    nameToKebab() {
      return this.toKebab(this.name);
    },
  },

  methods: {
    toKebab(value) {
      return value.split(' ').join('-').toLowerCase();
    },

  },
};
</script>

<style lang="scss" scoped>
label {
  pointer-events:none;
  left: .5rem;
  top: 10px;
  transition:0.2s ease all;
}

input {
    transition:0.2s ease all;
}

input:focus ~ label, input:valid ~ label {
  @apply text-black; @apply font-normal;
  top: -15px;
}
</style>
